import arbiePuppy from '../assets/arbie_puppy.png';

interface ArbieMascotProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function ArbieMascot({ className = '', size = 'md' }: ArbieMascotProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
  };

  return (
    <img
      src={arbiePuppy}
      alt="Arbie Recruiter Buddy Mascot"
      className={`${sizeClasses[size]} ${className} object-contain`}
    />
  );
}

export function ArbieLogo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <ArbieMascot size="md" />
      <div className="flex flex-col">
        <span className="font-bold text-lg leading-tight">Recruiter</span>
        <span className="font-bold text-lg leading-tight text-primary">Buddy</span>
      </div>
    </div>
  );
}
